import React, { useState, useEffect, useContext } from "react";
import peij from "../../../services/peij";
import { formatDateTime } from "../../../helpers/helpers";
import { CircularProgress } from "@mui/material";
import Form from "../../../components/form";
import AppContext from "../../../container/context";

const Parametros = ({ history, match }) => {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [parametros, setParametros] = useState({});

  useEffect(() => {
    carregar();
  }, []);

  const carregar = () => {
    setCarregando(true);

    peij
      .post("assinaturas/carregarParametrosVendas")
      .then((parametros) => {
        setParametros(parametros);
        setCarregando(false);
      })
      .catch((e) => {
        notification("error", "Não foi possível carregar os parâmetros");
        setCarregando(false);
      });
  };

  const camposParametros = (parametros) => ({
    expiracaoOfertaData: {
      label: "Expiração da oferta (data)",
      type: "date",
      value: parametros.expiracaoOferta
        ? formatDateTime(parametros.expiracaoOferta, "Y-M-D")
        : null,
      space: 3,
    },
    expiracaoOfertaHora: {
      label: "Expiração da oferta (hora)",
      type: "time",
      value: parametros.expiracaoOferta
        ? formatDateTime(parametros.expiracaoOferta, "h:m")
        : null,
      space: 3,
    },
    component: {
      type: "component",
      value: (
        <>
          <h4>Link grupo Whatsapp</h4>
          <a
            href={parametros.linkWhatsapp}
            target="_blank"
            rel="noopener noreferrer"
          >
            {parametros.linkWhatsapp}
          </a>
        </>
      ),
      space: 6,
    },
  });

  const salvar = (formulario) => {
    const parametrosSalvar = {
      expiracaoOferta: `${formulario.expiracaoOfertaData} ${formulario.expiracaoOfertaHora}`,
      linkWhatsapp: formulario.linkWhatsapp,
    };

    peij
      .post("assinaturas/salvarParametrosVendas", parametrosSalvar)
      .then((res) => {
        if (res.includes(200)) {
          notification("success", "Dados salvos!");
        } else {
          notification(
            "warning",
            "Não foi possível salvar. Verifique as informações."
          );
        }
      })
      .catch((e) => notification("error", "Erro ao salvar"));
  };

  const fForm = {
    form: camposParametros(parametros),
    submit: {
      label: "Salvar",
      action: salvar,
    },
    close: {},
    history,
  };

  return (
    <div>
      {carregando ? (
        <div style={{ textAlign: "center", marginTop: 50 }}>
          <CircularProgress color="info" />
        </div>
      ) : (
        <Form formData={fForm} />
      )}
    </div>
  );
};

export default Parametros;
